'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var APIVERSION = 1;

var Apps = function Apps(baseUrl, version, axios) {
    APIVERSION = '/' + version;

    return {

        getApps: function getApps(payload) {
            return axios.get(APIVERSION + '/apps').then(function (res) {
                return Promise.resolve(res);
            }).catch(function (e) {
                return Promise.reject(e);
            });
        },

        getMyApps: function getApps(payload) {},

        getApp: function getApp(APP_ID) {
            return axios.get(APIVERSION + '/apps/' + APP_ID).catch(function (error) {
                return Promise.reject(error);
            }).then(function (res) {
                if (res.status == 200) {
                    return Promise.resolve(res);
                } else {}
            });
        },

        createApp: function createApp(APP_ID) {
            return axios.put(APIVERSION + '/apps', APP_ID).then(function (res) {
                return res;
            }).catch(function (e) {
                return e;
            });
        },

        putApp: function getApps(payload) {},

        updateApp: function updateApp(payload) {

            return axios.put(APIVERSION + '/apps', payload).then(function (res) {
                return res;
            }).catch(function (e) {
                return e;
            });
        },
        deleteApps: function deleteApps(APP_ID) {
            return axios.delete(APIVERSION + '/apps/' + APP_ID).then(function (res) {
                return res;
            }).catch(function (e) {
                e;
            });
        }

    };
};

exports.default = Apps;